import { render, staticRenderFns } from "./callTotal.vue?vue&type=template&id=18ae86f4&scoped=true&"
import script from "./callTotal.vue?vue&type=script&lang=js&"
export * from "./callTotal.vue?vue&type=script&lang=js&"
import style0 from "./callTotal.vue?vue&type=style&index=0&id=18ae86f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae86f4",
  null
  
)

export default component.exports